import { Card, CardContent, CardHeader } from "@/components/ui/card";

import { ExternalLinkIcon } from "lucide-react";
import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useDebounce, getLogos } from "@/helpers/helperFunctions";
import { API_URL } from "@/config";
import Link from "next/link";
import Loader from "@/components/Loader";
import { MdClose } from "react-icons/md";
import StrategiesMarketplace from "./StrategiesMarketplace";
import { useTranslation } from "react-i18next";
import { useGetLogos } from "@/api/strategyApi";
import { useQuickStrategyContext } from "@/contexts/QuickStrategyContext";

export default function SuggestionPopup({ show, setShow, symbol }: any) {
  let [loading, setLoading] = useState(false);
  let [logos, setLogos] = useState<any>(new Map());
  let [data, setData] = useState([]);
  const { t } = useTranslation("marketplace-page");
  const { mutateAsync: getLogo, data: logoData } = useGetLogos();
  const { setQuickStrategyModalToggle } = useQuickStrategyContext();
  const fetchData = useCallback(
    useDebounce(() => {
      const url = new URL("/marketplace_filter_strategies", API_URL);
      const formData: any = new FormData();
      url.searchParams.append("page", String(1));
      url.searchParams.append("size", String(5));
      formData.append("symbol", symbol);
      axios
        .post(url.toString(), formData)
        .then((data: any) => {
          if (data?.statusText === "OK") {
            setData(data.data.items);
            if (data?.data) {
              let symbols = data?.data?.items;
              let finalData: any = symbols.map(
                (each: any) => each?.strategy?.symbol,
              );
              getLogo({ symbols: finalData });
            }
          } else {
            console.warn("Error fetching data:", data);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }, 500), // Debounce delay
    [symbol],
  );
  useEffect(() => {
    setLoading(true);
    fetchData();
  }, [symbol]);

  useEffect(() => {
    if (logoData) {
      setLogos((prev: {}) => ({
        ...prev,
        ...logoData?.data?.data, // merge new logo data into existing
      }));
    }
  }, [logoData]);

  if (data?.length == 0) {
    return null;
  }
  return (
    <Card className="shadow-lg w-[28vw] max-w-[550px] relative">
      <div
        className="absolute right-2 top-2 cursor-pointer text-lg"
        onClick={() => setShow(false)}
      >
        <MdClose />
      </div>
      <CardHeader className="p-4 pt-8 mt-1 text-sm flex flex-row items-center justify-between">
        <div className="font-semibold text-lg">{t("From the Marketplace")}</div>
        <Link
          onClick={() => setQuickStrategyModalToggle(false)}
          href={`/marketplace/${symbol}`}
          className="!mt-0 text-sm flex items-center text-[--accent-primary]"
        >
          Explore More <ExternalLinkIcon className="h-[15px]" />
        </Link>
      </CardHeader>
      <CardContent className="p-4 pb-5 pt-0">
        <div className="overflow-auto max-h-[50vh]">
          {loading ? (
            <div className="w-full h-[100px] flex items-center justify-center">
              <Loader />
            </div>
          ) : (
            <StrategiesMarketplace
              data={data}
              logos={logos}
              buildPage={true}
              isPopup={true}
            />
          )}
        </div>
      </CardContent>
    </Card>
  );
}
